<section class="border-border background-background" #section [class.readonly]="!selectedItem || disabled">
  <div class="content">
    <p class="name color-shape-text user-select-none">{{ selectedItem?.name }}</p>
    <p class="tables ml-1 user-select-none">({{ selectedItem?.tablesCount ? selectedItem.tablesCount : '0' }} tables)</p>
  </div>
  <div class="d-flex align-items-stretch">
    <div class="edit user-select-none" *ngIf="showEditButton">
      <tr-icon
        *ngIf="selectedItem !== undefined"
        [icon]="icon.edit"
        [size]="iconSize.medium"
        [color]="iconColor.blue"
        (click)="editPlan.emit(selectedItem)"
      ></tr-icon>
    </div>
    <div class="expand border-border user-select-none" (click)="expanded = !expanded">
      <tr-icon [icon]="expanded ? icon.arrowUp : icon.arrowDown" [size]="iconSize.small"></tr-icon>
    </div>
  </div>

  <div
    *ngIf="expanded"
    [style.top.px]="section.offsetHeight"
    [style.width.px]="section.offsetWidth"
    class="items border-border background-background"
  >
    <div
      *ngFor="let item of items; let i = index"
      (click)="select(item.id)"
      class="content item border-border user-select-none"
    >
      <p class="name color-shape-text user-select-none">{{ item.name }}</p>
      <p class="tables user-select-none">{{ item?.tablesCount ? item.tablesCount : '0' }} tables</p>
    </div>
  </div>
</section>
